import { composeWithDevTools } from '@redux-devtools/extension';
import { AnyAction } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore, Dispatch, Middleware } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import thunk from 'redux-thunk';

import { config } from './config';
import apiMiddleware from './middlewares/apiMiddleware';
import { reducers, RootState } from './reducers';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
	history: createBrowserHistory(),
});

// eslint-disable-next-line no-constant-condition
const myCompose: any = 'development' == 'development' ? composeWithDevTools : compose;

const loadState = (): any => {
	try {
		const serializedState = localStorage.getItem(config.localStorageStateName);
		if (serializedState === null) {
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
};

const saveState = (state: Partial<RootState>): void => {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem(config.localStorageStateName, serializedState);
	} catch {
		// U.debug('fufu2');
	}
};

export const store = createStore(reducers(routerReducer), loadState(), myCompose(applyMiddleware(routerMiddleware, thunk, apiMiddleware as Middleware<{}, RootState, Dispatch<AnyAction>>)));

store.subscribe(() => {
	saveState({
		auth: store.getState().auth,
		layout: store.getState().layout,
		category: store.getState().category, //todo: nema byt mali by to byt products
		modals: store.getState().modals,
	});
});

export const history = createReduxHistory(store);
